import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
    phone: '',
    id: 0,
    email: '',
    screenType: 0,
    loading: false,
    summary: {},
    errorText: '',
    modal: false,
});

export default function reduce(state = initialState, action = {}) {

    switch (action.type) {
        
        case types.CUSTOMER_SET:
            return state.merge({
                id: action.id,
                email: action.email,
                phone: action.phone,
                screenType: 1,
            });

        case types.PHONE_SET:
            return state.merge({
                phone: action.value,
                screenType: 1,
            });

        case types.SUMMARY_SET:
            return state.merge({
                summary: action.value,
            })

        case types.SCREEN_SET:
            return state.merge({
                screenType: action.value,
            });

        case types.LOADING_SET:
            return state.merge({
                loading: action.value,
            });

        case types.ERROR_SET:
            return state.merge({
                errorText: action.value,
            });

        case types.MODAL_SET:
            return state.merge({
                modal: action.value,
            });

        default:
            return state;
    }
}

export function getCustomerId(state) {
    return state.addCheck.id
}

export function getCustomerEmail(state) {
    return state.addCheck.email
}

export function getPhone(state) {
    return state.addCheck.phone
}

export function getScreenType(state) {
    return state.addCheck.screenType
}

export function getLoading(state) {
    return state.addCheck.loading
}

export function getError(state) {
    return state.addCheck.errorText
}

export function getModal(state) {
    return state.addCheck.modal
}

export function getSummary(state) {
    return state.addCheck.summary
}